import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { NavigationState } from '@/store/navigation/types'
import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'

export const navigation: Module<NavigationState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions
}
